<template lang="html">
    <div id="account">
        <header>
            Diary URL
            <router-link :to="{ name: 'Account' }"
                ><chevron-left-icon class="icon"></chevron-left-icon
            ></router-link>
        </header>

        <form class="form privacy">
            <div class="formGroup">
                <p class="help" style="margin-bottom: 20px">This is your personal diary URL.</p>

                <p class="help">
                    This feed is in ICS format, and can be imported into your calendar.
                </p>

                <p class="help divider" style="font-size: 18px">
                    <input
                        class="url-field"
                        type="text"
                        ref="urlfield"
                        :value="user.calendarFeedURL"
                    />
                    <button class="button" @click.prevent="copyToClipboard(user.calendarFeedURL)">
                        Copy to Clipboard
                    </button>
                </p>
            </div>
        </form>
    </div>
</template>

<script>
import { ChevronLeftIcon } from "vue-feather-icons";
export default {
    name: "privacy",
    components: { ChevronLeftIcon },
    data() {
        return {};
    },
    mounted() {},
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        async copyToClipboard(mytext) {
            try {
                await navigator.clipboard.writeText(mytext);
                this.$notify({
                    type: "success",
                    text: "Copied to clipboard",
                });
            } catch (e) {
                this.$notify({
                    type: "error",
                    text: "Could not copy to clipboard",
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.divider {
    margin-top: 20px;
    border-top: 1px solid #4b4e4c;
    padding-top: 20px;
}
#account .form .formGroup .url-field {
    font-size: 11px;
    text-align: center;
    letter-spacing: -0.5px;
    margin-bottom: 20px;
}
</style>
